var isFunction = function isFunction(value) {
  return typeof value === "function";
};

var __DEV__ = process.env.NODE_ENV !== "production";

var __TEST__ = process.env.NODE_ENV === "test";

export { __DEV__, __TEST__, isFunction };